module.exports = __webpack_public_path__ + "media/images/default-profile-4b51dff6e1dee96d45287d0a7b3404e5.jpg";